import { Link } from "react-router-dom";
import { Bars3Icon } from "@heroicons/react/24/outline";
import { Outlet } from "react-router-dom";
import NavMenu from "./NavMenu";
import { NavContext } from "../contexts/NavContext";
import { User } from "../utils/auth";
import { useContext } from "react";
import "./Layout.css";

interface LayoutProps {
  user: User | null;
  isMenuOpen: boolean;
  setIsMenuOpen: (open: boolean) => void;
  onLogout: () => void;
  onLogin: () => void;
}

const Layout: React.FC<LayoutProps> = ({ user, isMenuOpen, setIsMenuOpen, onLogout, onLogin }) => {
  const { title } = useContext(NavContext);
  return (
    <>
      <div className="nav-header">
        <div className="nav-left">
          <button className="menu-button" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <Bars3Icon className="h-6 w-6" />
          </button>
          {isMenuOpen && (
            <NavMenu user={user} onClose={() => setIsMenuOpen(false)} onLogout={onLogout} />
          )}
          <Link to="/" className="home-link">
            FifteenShared
          </Link>
        </div>
        {title && <div className="nav-center title">{title}</div>}
        <div className="user-info">{user?.username || "not logged in"}</div>
      </div>
      <Outlet context={{ user, onLogin }} />
    </>
  );
};

export default Layout;
export interface AuthContext {
  user: User | null;
  onLogin: () => void;
}
